import { createUseStyles } from 'react-jss';

export const addUserStyles = createUseStyles({
  container: {

  },
});
